export const FILES = {
  CONFIG: 'config.json',
  LOGO: 'logo.svg',
} as const;

export type FILES_LIST = (typeof FILES)[keyof typeof FILES];
